
const MoreFiltersList = [
    "null___already_shared_with_these_clients",
    "null___shared_with_clientid",
    "notnull___shared_with_clientid",
    "equalto___handed_over_to_client",
    "equalto___handed_over_to_an_employee_for_internal_use",
    "equalto___handed_over_to_an_employee_for_showcasing",
    "null___collection_code",
    "notDispatchOrOutOnLoan",
    "neverLiked"
]
const AttributesFilters = [
    "Color",
    "Fabric",
    "Hand",
    "Material",
    "Artwork",
    "Artist",
    "Effect",
    "Techniques",
    "Era",
]
const LocationFilters = [
    "subquery___amal_sharing___fk_client___fk_card___id",
    "containsany___location_id",
    "equalto___handed_over_to_userid",
    "sharedTillDate",
    "returnDate",
    "boxNumber"
]
const PrimaryFilters = [
    "Status",
    "cdnullorzero___first_approved_on",
]
export default function countFilters(Filters, setCount) {
    let MoreCount = MoreFiltersList.filter(itm => Filters[itm]).length;

    // Add sortBy to More count if it's not the default
    if (Filters.sortBy && Filters.sortBy !== "-created_at") {
        MoreCount += 1;
    }
    const AttributesCount = AttributesFilters.filter(itm => Filters[itm].length > 0).length;
    const PrimaryCount = PrimaryFilters.filter(itm => {
        const value = Filters[itm];
        return Array.isArray(value) ? value.length > 0 : value !== "" && value !== null && value !== undefined;
    }).length;
    const LocationCount = LocationFilters.filter(itm => {
        if (typeof (Filters[itm]) === "object") {
            if (Filters[itm].start && Filters[itm].end) {
                return true;
            }
        } else {
            if (Filters[itm] !== "") {
                return true;
            }
        }
        return false
    }).length

    const total = MoreCount + AttributesCount + PrimaryCount + LocationCount;

    setCount(prev => {
        return {
            ...prev,
            "More": MoreCount,
            "Attributes": AttributesCount,
            "Primary": PrimaryCount,
            "Location": LocationCount
        }
    })
    return total
}
